import { render, staticRenderFns } from "./TaskMonday.vue?vue&type=template&id=1e6663c5&"
import script from "./TaskMonday.vue?vue&type=script&lang=ts&"
export * from "./TaskMonday.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports